import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {}

export type Variables = {
  recId: number
  version: string
  positionId: number
  projectId: string
  articleNumber?: string
  amount?: number
  clippingAmount?: number
  price?: number
  customPrice?: string
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const CUSTOMIZE_ELEMENT_MUTATION = gql`
  mutation customizeElement(
    $recId: Float!
    $version: String!
    $positionId: Float!
    $projectId: String!
    $articleNumber: String
    $amount: Float
    $clippingAmount: Float
    $price: Float
    $customPrice: String
  ) {
    customizeElement(
      recId: $recId
      version: $version
      positionId: $positionId
      projectId: $projectId
      articleNumber: $articleNumber
      amount: $amount
      clippingAmount: $clippingAmount
      price: $price
      customPrice: $customPrice
    ) 
  }
`

const withCustomizeElementMutation = graphql<InputProps, Response, Variables, ChildProps>(
  CUSTOMIZE_ELEMENT_MUTATION,
  {
    name: 'customizeElementMutation',
  },
)

export default withCustomizeElementMutation
